import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertTriangle } from 'lucide-react';

interface Violation {
  rule: string;
  message: string;
  severity: 'ERROR' | 'WARNING';
  remediation?: string;
}

interface ComplianceViolationsProps {
  violations: Violation[];
}

export function ComplianceViolations({ violations }: ComplianceViolationsProps) {
  if (!violations || violations.length === 0) return null;

  return (
    <Alert variant="destructive" className="mb-4">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Compliance Issues Detected</AlertTitle>
      <AlertDescription>
        <ul className="list-disc pl-4 space-y-2 mt-2">
          {violations.map((v, i) => (
            <li key={i}>
              <strong>{v.rule}:</strong> {v.message}
              {v.remediation && (
                <p className="text-xs mt-1 text-muted-foreground">📋 {v.remediation}</p>
              )}
            </li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  );
}
